<template>
  <div class="grossing-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.grossing') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="grossingShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'GrossingHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            grossingShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.grossingGridTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.openSample'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.openSample')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.grossingFormTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.pathologicalReport'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'V' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.pathologicalReport')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.saveGrossing'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.saveGrossing')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.finalizeGrossing'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.finalizeGrossing')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.toggleSamplesPanel'),
                            shortcuts: [
                                { key: 'F2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.toggleSamplesPanel')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.sampleDetailsTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '1' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.sampleDetailSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.macroscopyTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.macroSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.blocksTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '3' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.blockSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.mediaTab'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '4' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.mediaSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addBlock'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '+' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addBlock')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.assayBlock'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'A' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.assays')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.textTemplatesTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.textTemplates'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'T' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.textTemplates')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.showTemplate'),
                            shortcuts: [
                                { key: null }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.showTemplate')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.nextField'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-right', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextField')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.previousField'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-left', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextField')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addTemplate'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addTemplate')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
